import { useRef, useCallback, useState } from "react";

const useInfiniteScroll = (callback) => {
  const observer = useRef();
  const [prevY, setPrevY] = useState(0);

  const lastElementRef = useCallback(
    (node) => {
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          const currentY = entry.boundingClientRect.y;

          // Trigger the callback only if scrolling vertically down
          if (entry.isIntersecting && currentY < prevY) {
            callback();
          }

          setPrevY(currentY); // Update previous Y position
        },
        {
          root: null,
          rootMargin: "0px",
          threshold: 1.0,
        }
      );

      if (node) observer.current.observe(node);
    },
    [callback, prevY]
  );

  return lastElementRef;
};

export default useInfiniteScroll;
